// extracted by mini-css-extract-plugin
export var serviceStandards = "index-module--serviceStandards--XS9L1";
export var serviceSwiper = "index-module--serviceSwiper--1WLe6";